import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useAnalyzeStore } from '../../stores/analyzeStore'

const fmt = (n: number) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Math.abs(n) || 0)

export function ReviewQueuePage() {
  const { reviewItems, reviewCount, loading, fetchReviewItems } = useAnalyzeStore()

  useEffect(() => { fetchReviewItems() }, [])

  return (
    <div className="space-y-6">
      <div>
        <Link to="/analyze" className="text-sm text-indigo-400 hover:underline">&larr; Back to Analyze</Link>
        <h2 className="mt-1 text-2xl font-bold text-white">Review Queue</h2>
        <p className="text-sm text-slate-400">{reviewCount} items need your attention</p>
      </div>

      {loading && <p className="text-slate-500">Loading...</p>}

      <div className="space-y-3">
        {reviewItems.map((item) => (
          <div key={item.id} className="rounded-xl border border-slate-700/50 bg-slate-800/80 p-4">
            <div className="flex items-start justify-between">
              <div>
                <p className="font-medium text-slate-200">{item.vendor}</p>
                <p className="text-sm text-slate-400">
                  {fmt(item.amount)} · {item.date}
                </p>
                {item.flags && (
                  <span className="mt-1 inline-block rounded-full bg-amber-500/20 px-2 py-0.5 text-xs font-medium text-amber-400">
                    {item.flags}
                  </span>
                )}
              </div>
            </div>
          </div>
        ))}
        {!loading && reviewItems.length === 0 && (
          <p className="py-12 text-center text-slate-500">All caught up! No items to review.</p>
        )}
      </div>
    </div>
  )
}
